import * as React from "react";

import { Button } from "@/components/ui/button";
import type { ControlDensity } from "@/lib/design-system/control-density";

type IconButtonSize = ControlDensity | "dense" | "inline" | "round" | "round-sm";

const buttonSizeBySize = {
  default: "icon",
  sm: "icon-sm",
  compact: "icon-compact",
  dense: "icon-dense",
  inline: "icon-inline",
  round: "icon-round",
  "round-sm": "icon-round-sm",
} as const;

type IconButtonProps = Omit<
  React.ComponentProps<typeof Button>,
  "variant" | "size"
> & {
  "aria-label": string;
  variant?: React.ComponentProps<typeof Button>["variant"];
  size?: IconButtonSize;
};

function IconButton({
  variant = "ghost",
  size = "sm",
  type = "button",
  ...props
}: IconButtonProps) {
  return (
    <Button
      type={type}
      variant={variant}
      size={buttonSizeBySize[size]}
      {...props}
    />
  );
}

export { IconButton };
export type { IconButtonProps, IconButtonSize };
